import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync, faMobileAlt, faSignOutAlt , faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';

function MobileRecharge({userData}) {
  
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    
    setTimeout(() => {
      setLoading(false);
      
        toast.error('Service currently unavailable');
      
    }, 1000); 
  };
  
  const operators = [
    { name: 'Airtel', code: '1' },
    { name: 'Vodafone Idea', code: '2' },
    { name: 'Reliance Jio', code: '3' },
    // Add more operators as needed
  ];
  
  useEffect(() => {
    document.title = "RupeeBuzz | Mobile Recharge";
  }, []);
  
  return(
    <div style={{fontFamily: "'Kanit', sans-serif", backgroundColor: "#f5f5f5"}}>
        <nav style={{zIndex: "99"}} className="navbar shadow-sm bg-body-tertiary">
      <div className="container-fluid">
<div className="navbar-brand d-flex align-items-center">
          <img src="https://icons.veryicon.com/png/o/object/a-group-of-daily-life-icons/wallet-73.png" alt="Logo" width="40" height="40" className="d-inline-block align-text-top"/>
          
          <div style={{fontWeight: "500", fontSize: "23px"}} className="mx-2">
          RupeeBuzz
        </div>
        
        </div>
                  <img style={{borderRadius: "50%", border: "1px solid #81bfff", padding: "2px"}} src={userData.pic} alt="Logo" width="40" height="40" className="d-inline-block align-text-top"/>
      </div>
    </nav>
  <div className="container p-3">
  <div className="text-start mb-3">
  <Link to="/" style={{fontSize: "20px", color: "#393939"}} className="text-decoration-none bg-transparent mb-3"><FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
</div>
  
  
  <div className="form-floating mb-3">
      <select className="form-select" id="floatingSelect" aria-label="Floating label select example" disabled>
        {operators.map(operator => (
          <option key={operator.code} value={operator.code}>{operator.name}</option>
        ))}
      </select>
      <label htmlFor="floatingSelect">Select SIM Operator</label>
    </div>
    
      <div className="form-floating mb-3">
      <select className="form-select" id="floatingSelect" aria-label="Floating label select example" disabled>
        <option defaultValue>Gujarat</option>

      </select>
      <label htmlFor="floatingSelect">Select Circle</label>
    </div>
  
  <div className="form-floating mb-3">
        <input type="text" className="form-control" id="floatingInput" value="799xxxx602" placeholder="Mobile Number" disabled/>
        <label htmlFor="floatingInput">Mobile Number</label>
      </div>
      <div className="form-floating mb-3">
        <input type="text" className="form-control" id="floatingPassword" placeholder="Plan" value="239 - 28 days, 2GB/DAY, UNLIMITED CALLS" disabled/>
        <label htmlFor="floatingPassword">Choose Plan</label>
      </div>
      
      
      <button onClick={handleClick} className="btn btn-primary mt-3 w-100"><FontAwesomeIcon icon={faMobileAlt} /> Recharge Now</button>
  
   <Toaster />
      
  
    </div>
    </div>
    );
}

export default MobileRecharge;